import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';

export default class UserGroupDTO extends DataTransferObject {

    public PDO_ID: number;

    public Name: string;

    public ErgNameToolTip: string;

    public DisplayName: string;

    public Description: string;

    public IsAllPrincipals: boolean;

    constructor() {
        super({ xmlProperties: ['PDO_ID', 'Name', 'DisplayName', 'Description', 'IsAllPrincipals'], xmlNamespace: 'RADFoundation.RoleAssignment' });

        this.PDO_ID = this.defaultFromType('long');
        this.Name = this.defaultFromType('string');
        this.DisplayName = this.defaultFromType('string');
        this.Description = this.defaultFromType('string');
        this.IsAllPrincipals = this.defaultFromType('bool');
    }
}

ComponentManager.setModel('UserGroupDTO', UserGroupDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');